// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"d13deb8a","453":"f36a44e0"}[chunkId] + ".chunk.js";
};